

















































































import { Observer } from 'mobx-vue'
import { Component, Inject, Vue } from 'vue-property-decorator'
import { FarmingViewModel } from '../viewmodels/farming-viewmodel'

@Observer
@Component
export default class extends Vue {
  @Inject() vm!: FarmingViewModel
}
